export function b64urlToUtf8(input: string): string {
  let s = input.replace(/-/g, '+').replace(/_/g, '/');

  const pad = s.length % 4;
  if (pad) {
    s += '='.repeat(4 - pad);
  }

  const bin = atob(s);
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));

  return new TextDecoder().decode(bytes);
}
